export const API_SURVEYS_DEFAULT_LIMIT = 10;
